import { ListMagnifyingGlassIcon } from '@phosphor-icons/react'
import type { ReactNode } from 'react'
import * as styles from './segments-labels.css'

export const NoAnalysisCircle: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.noAnalysisCircle}
  >
    <circle cx="12" cy="12" r="11" strokeWidth="2" strokeDasharray="6 6" />
  </svg>
)

export type SegmentLabelProps<TName extends string = string> = {
  name: TName
  percentage: number
  subLabel: string
  color: string
  icon?: ReactNode
}

type SegmentsLabelsProps = {
  labels: SegmentLabelProps[]
  icon?: ReactNode
}

const SegmentLabel: React.FC<SegmentLabelProps> = label => (
  <div className={styles.label}>
    {label.icon ?? (
      <span
        data-testid={`segment-label-dot-${label.name}`}
        className={styles.dot}
        style={{ backgroundColor: label.color }}
      />
    )}
    <div>
      <div className={styles.labelName}>
        {label.name} ({label.percentage.toFixed(0)}%)
      </div>
      <div className={styles.subLabel}>{label.subLabel}</div>
    </div>
  </div>
)

export const SegmentsLabels: React.FC<SegmentsLabelsProps> = ({ labels, icon }) => {
  return (
    <div className={styles.container}>
      <div className={styles.leadingIcon}>
        {icon ?? <ListMagnifyingGlassIcon className={styles.leadingIconSvg} weight="light" />}
      </div>
      {labels.map(label => (
        <SegmentLabel key={label.name} {...label} />
      ))}
    </div>
  )
}
